module.exports = __webpack_public_path__ + "static/media/DJVU.5cfc5a73.svg";